<template>
  <Header />
  <!-- 悬浮 header 不透明时的占位符 -->
  <div v-show="route.name !== 'index'" style="height: 80px"></div>
  <div class="protocol-page">
    <slot />
  </div>
  <Footer />
  <BackTop />
</template>

<script setup lang="ts">
import Header from '@/views/layouts/default/header.vue'
import Footer from '@/views/layouts/default/footer.vue'
import BackTop from '@/components/backTop.vue'
import { useRoute } from '#imports'

const route = useRoute()
</script>

<style lang="scss" scoped>
.protocol-page {
  min-width: var(--pc-page-min-width);
  background: linear-gradient(
    164deg,
    #372a6b 2.92%,
    #191635 25.8%,
    #131124 41.03%,
    #131124 52.37%,
    #16142c 64.64%,
    #1f1a46 77.04%,
    #2f2771 89.1%
  );
  padding: 72px 0;
}

@media screen and (orientation: portrait) {
  .protocol-page {
    min-width: 100vw;
  }
}
</style>

<!-- 子页面使用的 css -->
<style lang="scss">
.protocol-page {
  .content {
    width: 1200px;
    margin: 0 auto;
    color: rgba(255, 255, 255, 0.7);
    font-size: 24px;
    line-height: 40px;

    .title {
      font-size: 28px;
      font-weight: 600;
      line-height: 51px;
      margin-bottom: 10px;
    }
  }
}

@media screen and (orientation: portrait) {
  .protocol-page {
    .content {
      width: 100vw;
    }
  }
}
</style>
